import { useEffect, useContext, useRef } from 'react';

import { AuthContext } from '../../';
import { AUTH_ERROR } from '../../constants';

import { AUTH_TOKEN_REQUESTS_TIMEOUT } from '../constants';

function useTokenTimeout() {
  const {
    authDispatch,
    auth: { token },
  } = useContext(AuthContext);
  const tokenTimout = useRef(null);

  useEffect(() => {
    tokenTimout.current = setTimeout(() => {
      authDispatch({
        type: AUTH_ERROR,
        payload: { error: 'Auth token requests timeout' },
      });
    }, AUTH_TOKEN_REQUESTS_TIMEOUT);

    return () => {
      clearTimeout(tokenTimout.current);
    };
  }, []);

  useEffect(() => {
    if (token) {
      clearTimeout(tokenTimout.current);
    }
  }, [token]);
}

export default useTokenTimeout;
